import { AppThunk } from 'redux/store';
import {
  GetAadhaarCardDetailsType,
  GetExperianType,
  GetKycDetailsType,
  GetVerifyBankAccountType,
  GetVerifyDocumentType,
  GetVerifyIFCSType,
  ISetAuthDataStorage,
  IUserVerifySetAuthDataStorage,
  OzLivenessResultType,
  PatchUserType,
  PostConfirmationCodeExperianType,
  PostVerifyBankAccountType,
  SendAadhaarNumberType,
  SendAadhaarOtpType,
  SendConfirmationCodeExperianType,
  SendOTPUser,
  SetuDataAnalysisType,
  TypesUser,
  UploadPanCardType,
  UserVerifyOtpType,
  VerifyDocumentType,
} from './type';
import WebApi from 'core/services/WebApi';
import { logout, redirect, setAlert } from 'core/redux/actions/lyaout/action';
import {
  getStorageRefreshToken,
  getStorageUserId,
  removeStoragePhoneLogin,
  setStorageAuthToken,
  setStoragePhoneLogin,
  setStorageRefreshToken,
  setStorageUserId,
  removeAllCookies,
  getLocalStorageSeonFingerPrint,
  setStorageIsUserRegistered,
  removeStorageSaveInitValue,
  getStorageAuthToken,
  setStorageForensicsAccessToken,
  setStorageForensicsTransactionId,
  getStorageForensicsTransactionId,
  removeStorageForensicsAccessToken,
  removeStorageForensicsTransactionId,
  setStorageSelfieRequest,
  removeStorageSelfieRequest,
  setStorageIsExperianRequestExist,
  setIsRetryAfterExist,
  getIsRetryAfterExist,
  removeIsRetryAfterExist,
  setStorageIsCountdownWorking,
  removeStorageIsCountdownWorking,
  handleAadhaarVerificationEngineChange,
} from 'utils';
import SETTINGS from 'core/settings';
import store from 'redux/store';
import {
  AadhaarCardStatus,
  IForensicsDetails,
  VerifyBankAccountState,
  VerifyDocumentRequestState,
} from 'redux/reducers/user/type';
import { getDelay } from 'utils/functions/getDelay';
import { AlertType } from 'core/redux/reducers/layout/type';
import { getUserInfoZoop } from 'utils/functions/getUserInfoZoop';
import { getListOfStates } from '../index';
import {
  ALERTS_DEFAULT_TIMEOUT_VALUE,
  ALERTS_LONG_TIME_TIMEOUT_VALUE,
  PATH_ACC_APPLICATION,
  PATH_DOCUMENTS_AADHAAR_OTP,
  PATH_DOCUMENTS_AADHAAR_VERIFICATION,
  TARGET_URL,
  UserRegisteredStatus,
} from 'const';
import * as steps from 'const/paths';
import { onSubmitEventTagHandler } from 'utils/analytics/onSubmitEventTagHandler';
import { GTM_LABEL_SIGN_UP } from 'utils/analytics/gtmLabel';

declare global {
  interface Window {
    fingerPrint: any;
    jslabApi: any;
    dataLayer: any;
    HyperSnapSDK: any;
    HVFaceModule: any;
    HVFaceConfig: any;
    HyperSnapParams: any;
    OzLiveness: any;
    Cashfree: any;
  }
}

const dispatch = store.dispatch;

WebApi.SETTINGS_REQUEST.eventCheckUnauthorized = (error) => {
  const { response } = error;
  if (response) {
    if (response.status === 401 && response?.data?.message === 'Authentication failed') {
      return true;
    }
  }

  return false;
};

WebApi.SETTINGS_REQUEST.eventRefreshToken = () =>
    new Promise<void>((resolve, reject) => {
      if (!getStorageRefreshToken() || !getStorageUserId()) {
        reject(false);
      }

      dispatch({ type: TypesUser.REFRESH_TOKEN_USER_REQUEST });

      return WebApi.request({
        method: 'POST',
        url: '/api/refresh_token',
        data: {
          user_id: getStorageUserId(),
          refresh_token: getStorageRefreshToken(),
        },
        onSuccess: (data) => {
          dispatch({ type: TypesUser.REFRESH_TOKEN_USER_SUCCESS });
          dispatch(setAuthDataStorage({ ...data, ...data.user }));
          resolve(data);
        },
        onFailed: (error) => {
          dispatch({ type: TypesUser.REFRESH_TOKEN_USER_ERROR });
          dispatch(redirect(SETTINGS.pathLogin));
          dispatch(logout());
          reject(error);
        },
        isAuth: false,
      });
    });

export const setAuthDataStorage =
    (data: ISetAuthDataStorage): AppThunk<void> =>
        () => {
          setStorageAuthToken(data.token);
          setStorageRefreshToken(data.refresh_token);
          setStorageUserId(+data.id);
        };

export const setUserVerifySetAuthDataStorage =
    (data: IUserVerifySetAuthDataStorage): AppThunk<void> =>
        () => {
          setStorageAuthToken(data.token.token);
          setStorageRefreshToken(data.token.refresh_token);
          setStorageUserId(+data.token.user.id);
        };

export const removeAuthDataStorage = (): AppThunk<void> => () => {
  removeAllCookies();
  localStorage.clear();
  sessionStorage.clear();
  dispatch(redirect(steps.PATH_LOGIN));
};

export const setOzLivenessAuthDataStorage =
    (data: IForensicsDetails): AppThunk<void> =>
        () => {
          setStorageForensicsAccessToken(data.access_token);
          setStorageForensicsTransactionId(data.transaction_id);
        };

export const clearLoginSession = (): AppThunk => (dispatch) => {
  dispatch(() => removeStoragePhoneLogin());
  dispatch(removeAuthDataStorage());

  dispatch({ type: TypesUser.CLEAR_LOGIN_SESSION });
};

export const clearUser = (): AppThunk => (dispatch) => {
  dispatch({ type: TypesUser.CLEAR_USER });
};

export const clearVerifyIFCS = (): AppThunk => (dispatch) => {
  dispatch({ type: TypesUser.CLEAR_VERIFY_IFCS });
};

export const setAlertWithTimer = (error: any) => {
  const headers = error.data.headers;
  const retryAfter = headers['retry-after'];

  !!retryAfter && dispatch(saveRetryAfter(retryAfter));

  const alertData = {
    textData: {
      message: `Try again after ${retryAfter} seconds`,
    },
    type: AlertType.Error,
  };
  dispatch(setAlert(alertData));
};

export const getUserInfo =
    (userId?: number): AppThunk<void> =>
        (dispatch, getState) => {
          dispatch({ type: TypesUser.GET_USER_INFO_REQUEST });
          const state = getState();
          const { id } = state.user.userInfo;

          return WebApi.request({
            method: 'GET',
            url: `/api/users/${userId || id}`,
            onSuccess: (data) => {
              dispatch({ type: TypesUser.GET_USER_INFO_SUCCESS, data });
            },
            onFailed: () => {
              dispatch({ type: TypesUser.GET_USER_INFO_ERROR });
            },
            isAuth: true,
          });
        };

export const getUserAadhaarVerificationInfo =
    (
        data = {
          token: null,
          url: null,
          sessionClientId: null,
        }
    ): AppThunk<void> =>
        (dispatch) => {
          dispatch({ type: TypesUser.SET_AADHAAR_VERIFICATION_INFO, data: data });
        };

export const getUserAadhaarVerificationConfig =
    (params: {
      clientId: number;
      aadhaarNumber: string;
      successCallback: (data: { token: string; client_id: string }) => void;
      errorCallback: () => void;
    }): AppThunk =>
        (dispatch) => {
          const { clientId, aadhaarNumber, successCallback, errorCallback } = params;

          return WebApi.request({
            method: 'POST',
            url: `api/users/${clientId}/aadhaar_number/digilocker/initialize`,
            data: { aadhaar_number: aadhaarNumber },
            onSuccess: (data) => {
              dispatch({ type: TypesUser.SET_AADHAAR_VERIFICATION_INFO, data: data });

              successCallback(data);
            },
            onFailed: (error) => {
              handleAadhaarVerificationEngineChange(error?.data?.status, () =>
                  dispatch({ type: TypesUser.SET_AADHAAR_VERIFICATION_INFO, data: error })
              );

              errorCallback();
            },
            isAuth: true,
          });
        };

export const getUserAadhaarVerificationStatus =
    (params: {
      clientId: number;
      sessionClientId: string;
      successCallback: () => void;
      errorCallback?: () => void;
    }): AppThunk =>
        (dispatch) => {
          const { clientId, sessionClientId, successCallback, errorCallback } = params;

          return WebApi.request({
            method: 'POST',
            url: `/api/users/${clientId}/aadhaar_number/digilocker/status`,
            data: { client_id: sessionClientId },
            onSuccess: (data) => {
              if (data.status) {
                dispatch({ type: TypesUser.SET_AADHAAR_VERIFICATION_INFO, data: data });

                successCallback();
              }
            },
            onFailed: (error) => {
              handleAadhaarVerificationEngineChange(error?.data?.status, () => {
                const alertData = {
                  textData: {
                    message: error?.data?.content?.text ?? 'Something went wrong. Please try again.',
                  },
                  type: AlertType.Error,
                };

                dispatch(setAlert(alertData));

                errorCallback?.();
              });
            },
            isAuth: true,
          });
        };

export const getPreferableLanguages = (): AppThunk<void> => (dispatch) => {
  dispatch({ type: TypesUser.GET_PREFERABLE_LANGUAGES_REQUEST });

  return WebApi.request({
    method: 'GET',
    url: `/api/dictionary/preferable_language`,
    onSuccess: (data) => {
      dispatch({ type: TypesUser.GET_PREFERABLE_LANGUAGES_SUCCESS, data });
    },
    onFailed: () => {
      dispatch({ type: TypesUser.GET_PREFERABLE_LANGUAGES_ERROR });
    },
    isAuth: true,
  });
};

export const patchUser: PatchUserType = (data) => (dispatch, getState) => {
  const { values, onFailed, onSuccess } = data;
  const state = getState();
  const {
    userInfo: { id },
  } = state.user;

  const storageUserId = getStorageUserId();

  const userId = id || storageUserId;

  dispatch({ type: TypesUser.PATCH_USER_REQUEST });

  return WebApi.request({
    method: 'PATCH',
    url: `/api/users/${userId}`,
    data: values,
    headers: {
      'Content-Type': 'application/merge-patch+json',
    },
    onSuccess: (data) => {
      onSuccess && onSuccess();
      dispatch({ type: TypesUser.PATCH_USER_SUCCESS, data, values });
    },
    onFailed: (error) => {
      dispatch({ type: TypesUser.PATCH_USER_ERROR });
      onFailed && onFailed(error.data);
    },
    isAuth: true,
  });
};

export const removeRetryAfter = (): AppThunk<void> => (dispatch) => {
  dispatch({ type: TypesUser.REMOVE_RETRY_AFTER });
  removeStorageIsCountdownWorking();
  removeIsRetryAfterExist();
};

export const saveRetryAfter =
    (seconds: number): AppThunk<void> =>
        (dispatch) => {
          dispatch({ type: TypesUser.SAVE_RETRY_AFTER, data: seconds });

          dispatch(() => setStorageIsCountdownWorking('true'));
          dispatch(() => setIsRetryAfterExist('true'));
        };

export const isCookiesXDryRunExist = getIsRetryAfterExist();

export const xDryRunUserRequest: SendOTPUser = (params) => (dispatch) => {
  const { values } = params;

  return WebApi.request({
    method: 'POST',
    url: 'api/auth/user/request',
    headers: { 'X-Dry-Run': 1 },
    data: {
      ...values,
    },
    onSuccess: () => {},
    onFailed: () => {},
    isAuth: false,
  });
};

export const userRequestOtp: SendOTPUser = (params) => async (dispatch, getState) => {
  dispatch({ type: TypesUser.SEND_OTP_USER_REQUEST });
  const { values, onFailed, onFinally, onSuccess } = params;

  const target_url = localStorage.getItem(TARGET_URL);

  const response = await WebApi.request({
    method: 'POST',
    url: 'api/auth/user/request',
    data: {
      ...values,
      target_url: target_url,
    },
    onSuccess: (data) => {
      onSuccess && onSuccess(data);
      if (data.is_user_confirmation) {
        localStorage.setItem('is_user_confirmation', 'true');
      }
      setStorageIsUserRegistered(UserRegisteredStatus.TRUE);
    },
    onFailed: (error) => {
      if (error.data.status === 429) {
        setAlertWithTimer(error);
      }

      if (error.data.message === 'User not found.') {
        setStorageIsUserRegistered(UserRegisteredStatus.FALSE);
      }

      dispatch({ type: TypesUser.SEND_OTP_USER_ERROR });
      onFailed && onFailed(error.data);
    },
    onFinally: () => {
      onFinally?.();

      setStoragePhoneLogin(values.username || '');
      dispatch({ type: TypesUser.SEND_OTP_USER_SUCCESS, data: values.username });
    },
    isAuth: false,
  });

  const retryAfter = response.request.getResponseHeader('retry-after');

  !!retryAfter && dispatch(saveRetryAfter(retryAfter));
};

export const xDryRunUserVerifyOtp = (): AppThunk<void> => (dispatch) => {
  return WebApi.request({
    headers: { 'X-Dry-Run': 1 },
    method: 'POST',
    url: 'api/auth/user/verify',

    onSuccess: () => {},
    onFailed: () => {},
    isAuth: false,
  });
};

export const userVerifyOtp: UserVerifyOtpType =
    (params): AppThunk<void> =>
        async (dispatch) => {
          dispatch({ type: TypesUser.LOGIN_OTP_USER_REQUEST });
          const { values, onSuccess, onFailed, onFinally } = params;

          const seonSessionFingerPrint = getLocalStorageSeonFingerPrint();

          const storageAuthToken = getStorageAuthToken();
          const storageUserId = getStorageUserId();

          const headers = storageAuthToken
              ? {
                'X-AUTH-TOKEN': storageAuthToken,
              }
              : {};

          const response = await WebApi.request({
            headers: headers,
            method: 'POST',
            url: 'api/auth/user/verify',
            data: {
              ...values,
              // @ts-ignore
              user_additional_data: {
                seon: {
                  session: seonSessionFingerPrint,
                },
                // @ts-ignore
                juicy_score_session_id: window?.jslabApi?.getSession && window?.jslabApi?.getSession(),
              },
            },

            onSuccess: (data) => {
              onSuccess && onSuccess();
              const isImpersonateLogin = !data.token.user;

              !isImpersonateLogin &&
              dispatch(setUserVerifySetAuthDataStorage({ ...data, ...data.token.user }));
              dispatch(getUserInfo(isImpersonateLogin ? storageUserId : data.token.user.id));

              dispatch({ type: TypesUser.LOGIN_OTP_USER_SUCCESS });

              removeStoragePhoneLogin();
              removeStorageSaveInitValue();
              dispatch(removeRetryAfter());
              removeIsRetryAfterExist();
            },
            onFailed: (error) => {
              if (error.data.status === 429) {
                setAlertWithTimer(error);
              }

              onFailed && onFailed(error);
              dispatch({ type: TypesUser.LOGIN_OTP_USER_ERROR });

              onFailed?.(error);
            },
            onFinally: () => {
              onFinally?.();
            },
            isAuth: false,
          });

          const retryAfter = response.request.getResponseHeader('retry-after');

          !!retryAfter && dispatch(saveRetryAfter(retryAfter));
        };

export const getUserPayments = (): AppThunk<void> => (dispatch, getState) => {
  dispatch({ type: TypesUser.GET_USER_PAYMENTS_REQUEST });
  const state = getState();
  const { id } = state.user.userInfo;

  return WebApi.request({
    method: 'GET',
    url: `/api/users/${id}/incomes`,
    onSuccess: (data) => {
      dispatch({ type: TypesUser.GET_USER_PAYMENTS_SUCCESS, data });
    },
    onFailed: () => {
      dispatch({ type: TypesUser.GET_USER_PAYMENTS_ERROR });
    },
    isAuth: true,
  });
};

export const verifyDocument: VerifyDocumentType = (params) => (dispatch, getState) => {
  const { onSuccess, onFailed, ...rest } = params;
  const state = getState();
  const { id } = state.user.userInfo;

  dispatch({ type: TypesUser.POST_VERIFY_DOCUMENT_REQUEST });

  return WebApi.request({
    method: 'POST',
    url: `/api/users/${id}/verify_document`,
    data: rest,
    onSuccess: (data) => {
      dispatch({ type: TypesUser.POST_VERIFY_DOCUMENT_SUCCESS, data });
      dispatch(
          getVerifyDocument({ KYCRequestId: data.request_id, type: params.document_type, onSuccess })
      );
    },
    onFailed: (error) => {
      const alertData = {
        textData: {
          message: 'error_message_an_error_occurred',
        },
        type: AlertType.Error,
      };

      onFailed && onFailed(error.data);
      dispatch(setAlert(alertData));
      dispatch({
        type: TypesUser.POST_VERIFY_DOCUMENT_ERROR,
        data: { request_error: 'error_message_an_error_occurred' },
      });
    },
  });
};

export const getVerifyDocument: GetVerifyDocumentType = (params) => (dispatch, getState) => {
  const { KYCRequestId } = params;
  const state = getState();
  const { id } = state.user.userInfo;

  dispatch({ type: TypesUser.GET_VERIFY_DOCUMENT_REQUEST });

  return WebApi.request({
    method: 'GET',
    url: `/api/users/${id}/verify_document/${KYCRequestId}`,
    onSuccess: (data) => {
      const getRetry = async () => {
        await getDelay(3000);
        dispatch(getVerifyDocument(params));
      };

      switch (data.request_state) {
        case VerifyDocumentRequestState.Pending:
          return getRetry();

        case VerifyDocumentRequestState.PROCESSED:
          return dispatch({ type: TypesUser.GET_VERIFY_DOCUMENT_SUCCESS, data });

        case VerifyDocumentRequestState.ERROR:
          return dispatch({
            type: TypesUser.GET_VERIFY_DOCUMENT_ERROR,
            data: {
              data,
              request_error: 'error_message_an_error_occurred',
            },
          });

        default:
          dispatch({
            type: TypesUser.GET_VERIFY_DOCUMENT_ERROR,
            data: { request_error: 'error_message_an_error_occurred' },
          });
      }
    },
    onFailed: () => {
      dispatch({
        type: TypesUser.GET_VERIFY_DOCUMENT_ERROR,
        data: { request_error: 'error_message_an_error_occurred' },
      });
    },
  });
};

export const getAadhaarCardDetails: GetAadhaarCardDetailsType =
    (params) => (dispatch, getState) => {
      const { aadhaar_number, isPending = false, onSuccess, onFailed } = params;
      const { id } = getState().user.userInfo;

      dispatch({ type: TypesUser.GET_AADHAAR_CARD_DETAILS_REQUEST });

      return WebApi.request({
        method: 'GET',
        url: `/api/users/${id}/aadhaar_number/details?aadhaar_number=${aadhaar_number}`,
        onSuccess: async (res) => {
          const getRetry = async () => {
            await getDelay(3000);
            dispatch(getAadhaarCardDetails(params));
          };

          switch (res.status) {
            case AadhaarCardStatus.Pending: {
              if (isPending) {
                return onSuccess && onSuccess();
              }
              return getRetry();
            }

            case AadhaarCardStatus.SUCCESS: {
              const userDataZoop = getUserInfoZoop(res);

              await dispatch(getListOfStates());
              const listOfStates = getState().userApplications.listOfStates;

              const normalize = (value?: string | null) => value?.trim().toLowerCase();
              const matchedState = listOfStates?.find(
                  (v) => normalize(v.name) === normalize(userDataZoop.registration_address_state)
              );
              const registration_state_code = matchedState ? `${matchedState.id}` : null;

              const userDataValues = { ...userDataZoop, registration_state_code };

              dispatch(removeRetryAfter());
              removeIsRetryAfterExist();

              dispatch(patchUser({ values: userDataValues, onSuccess }));
              removeStorageSaveInitValue();

              return dispatch({ type: TypesUser.GET_AADHAAR_CARD_DETAILS_SUCCESS, data: res });
            }

            case AadhaarCardStatus.ERROR: {
              const alert = {
                textData: {
                  message: 'error_message_an_error_occurred',
                },
                type: AlertType.Error,
              };

              onSubmitEventTagHandler(
                  {
                    message: 'error_message_an_error_occurred',
                  },
                  GTM_LABEL_SIGN_UP,
                  'aadhaar_verification_start'
              );

              dispatch(setAlert(alert));
              setTimeout(() => dispatch(redirect(PATH_DOCUMENTS_AADHAAR_VERIFICATION)), 3000);
              onFailed && onFailed('AadhaarCardStatus.ERROR');
              return;
            }

            case AadhaarCardStatus.FAILURE: {
              const alert = {
                textData: {
                  message: 'error_message_aadhaar_number_is_not_valid',
                },
                type: AlertType.Error,
              };

              dispatch(setAlert(alert));
              onSubmitEventTagHandler(
                  {
                    message: 'error_message_aadhaar_number_is_not_valid',
                  },
                  GTM_LABEL_SIGN_UP,
                  'aadhaar_verification_start'
              );
              onFailed && onFailed();
              setTimeout(() => dispatch(redirect(PATH_DOCUMENTS_AADHAAR_VERIFICATION)), 3000);
              return dispatch({ type: TypesUser.GET_AADHAAR_CARD_DETAILS_ERROR });
            }

            default:
              return getRetry();
          }
        },
        // onSuccess: (res) => {
        //   dispatch(getListOfStates());
        //   const listOfStates = state.userApplications.listOfStates;
        //
        //   const getRetry = async () => {
        //     await getDelay(3000);
        //     dispatch(getAadhaarCardDetails(params));
        //   };
        //
        //   switch (res.status) {
        //     case AadhaarCardStatus.Pending: {
        //       if (isPending) {
        //         return onSuccess && onSuccess();
        //       }
        //       return getRetry();
        //     }
        //
        //     case AadhaarCardStatus.SUCCESS:
        //       const userDataZoop = getUserInfoZoop(res);
        //
        //       const registration_state_code =
        //         listOfStates &&
        //         `${
        //           Object.values(
        //             listOfStates?.filter((v) => v.name === userDataZoop.registration_address_state)
        //           )[0].id
        //         }`;
        //
        //       const userDataValues = { ...userDataZoop, registration_state_code };
        //
        //       dispatch(removeRetryAfter());
        //       removeIsRetryAfterExist();
        //
        //       dispatch(patchUser({ values: userDataValues, onSuccess }));
        //       removeStorageSaveInitValue();
        //
        //       return dispatch({ type: TypesUser.GET_AADHAAR_CARD_DETAILS_SUCCESS, data: res });
        //
        //     case AadhaarCardStatus.ERROR: {
        //       const alert = {
        //         textData: {
        //           message: 'error_message_an_error_occurred',
        //         },
        //         type: AlertType.Error,
        //       };
        //
        //       onSubmitEventTagHandler(
        //         {
        //           message: 'error_message_an_error_occurred',
        //         },
        //         GTM_LABEL_SIGN_UP,
        //         'aadhaar_verification_start'
        //       );
        //
        //       dispatch(setAlert(alert));
        //       setTimeout(() => dispatch(redirect(PATH_DOCUMENTS_AADHAAR_VERIFICATION)), 3000);
        //       onFailed && onFailed('AadhaarCardStatus.ERROR');
        //       return;
        //     }
        //
        //     case AadhaarCardStatus.FAILURE: {
        //       const alert = {
        //         textData: {
        //           message: 'error_message_aadhaar_number_is_not_valid',
        //         },
        //         type: AlertType.Error,
        //       };
        //
        //       dispatch(setAlert(alert));
        //       onSubmitEventTagHandler(
        //         {
        //           message: 'error_message_aadhaar_number_is_not_valid',
        //         },
        //         GTM_LABEL_SIGN_UP,
        //         'aadhaar_verification_start'
        //       );
        //       onFailed && onFailed();
        //       setTimeout(() => dispatch(redirect(PATH_DOCUMENTS_AADHAAR_VERIFICATION)), 3000);
        //       return dispatch({ type: TypesUser.GET_AADHAAR_CARD_DETAILS_ERROR });
        //     }
        //
        //     default:
        //       return getRetry();
        //   }
        // },
        onFailed: (error) => {
          if (error.data.status === 424) {
            const auto_close_after_secs = error.data.auto_close_after_secs;
            const closable = error.data.closable;
            const mode = error.data.mode;
            const severity = error.data.severity;
            const content = error.data.content;
            const contentText = error.data.content[0].text;
            const header = error.data.header;

            const timeout = error.data.timeout / 1000;
            const alert = {
              textData: {
                message: contentText,
              },
              type: AlertType.Error,
              timeout: timeout,
              mode: mode,
              auto_close_after_secs: auto_close_after_secs,
              closable: closable,
              severity: severity,
              header: header,
              content: content,
            };

            const defaultTimeout =
                auto_close_after_secs === 0
                    ? ALERTS_LONG_TIME_TIMEOUT_VALUE
                    : auto_close_after_secs && auto_close_after_secs > 0
                        ? auto_close_after_secs
                        : ALERTS_DEFAULT_TIMEOUT_VALUE;

            dispatch(setAlert(alert));

            setTimeout(() => window.location.reload(), defaultTimeout);
          }
          onFailed && onFailed(error);
          return dispatch({ type: TypesUser.GET_AADHAAR_CARD_DETAILS_ERROR });
        },
      });
    };

export const xDryRunAadhaarCardNumber: SendAadhaarNumberType = (params) => (dispatch, getState) => {
  const { aadhaar_number, onFailed, onSuccess } = params;
  const state = getState();
  const { id } = state.user.userInfo;

  return WebApi.request({
    method: 'POST',
    url: `/api/users/${id}/aadhaar_number/request_otp`,
    headers: { 'X-Dry-Run': 1 },
    data: { aadhaar_number },
    onSuccess: (data) => {
      onSuccess && onSuccess();
    },
    onFailed: (error) => {
      onFailed && onFailed(error.data);
    },
  });
};

export const sendAadhaarCardNumber: SendAadhaarNumberType =
    (params) => async (dispatch, getState) => {
      const { aadhaar_number, onFailed, onSuccess } = params;
      const state = getState();
      const { id } = state.user.userInfo;

      dispatch({ type: TypesUser.SEND_AADHAAR_CARD_NUMBER_REQUEST });

      const response = await WebApi.request({
        method: 'POST',
        url: `/api/users/${id}/aadhaar_number/request_otp`,
        data: { aadhaar_number },
        onSuccess: (data) => {
          onSuccess && onSuccess();
          dispatch({ type: TypesUser.SEND_AADHAAR_CARD_NUMBER_SUCCESS, data });
        },
        onFailed: (error) => {
          if (error.data.status === 410) {
            const alert = {
              textData: {
                message: 'error_message_an_error_occurred',
                serverMessage: error.data.error,
              },
              type: AlertType.Error,
            };

            const headers = error.data.headers;
            const retryAfter = headers['retry-after'];

            !!retryAfter && dispatch(saveRetryAfter(retryAfter));

            dispatch(setAlert(alert));
            setTimeout(() => dispatch(redirect(PATH_DOCUMENTS_AADHAAR_OTP)), 3000);
          }

          if (error.data.status === 403) {
            const alert = {
              textData: {
                message: 'error_message_an_error_occurred',
                serverMessage: error.data.error,
              },
              type: AlertType.Error,
            };

            dispatch(setAlert(alert));
          }

          if (error.data.status === 429) {
            const alertData = {
              textData: {
                message: error.data.detail,
              },
              type: AlertType.Error,
            };

            const headers = error.data.headers;
            const retryAfter = headers['retry-after'];

            !!retryAfter && dispatch(saveRetryAfter(retryAfter));

            onFailed && onFailed(error.data);
            dispatch(setAlert(alertData));
          }

          if (error.data.status === 400) {
            const alert = {
              textData: {
                message: error.data.detail,
              },
              type: AlertType.Error,
            };

            dispatch(setAlert(alert));
          }

          handleAadhaarVerificationEngineChange(error?.data?.status);

          onFailed && onFailed();
          dispatch({ type: TypesUser.SEND_AADHAAR_CARD_NUMBER_ERROR });
        },
        onFinally: () => {},
      });

      const retryAfter = response.request.getResponseHeader('retry-after');

      !!retryAfter && dispatch(saveRetryAfter(retryAfter));
    };

export const sendAadhaarOtp: SendAadhaarOtpType = (params) => (dispatch, getState) => {
  const { otp, onSuccess, onFailed } = params;
  const state = getState();
  const { id } = state.user.userInfo;
  dispatch({ type: TypesUser.SEND_AADHAR_OTP_USER_REQUEST });

  return WebApi.request({
    method: 'POST',
    url: `/api/users/${id}/aadhaar_number/verify_otp`,
    data: { otp },
    onSuccess: () => {
      onSuccess && onSuccess();
      dispatch({ type: TypesUser.SEND_AADHAR_OTP_USER_SUCCESS });
    },
    onFailed: (error) => {
      if (error.status === 404) {
        const alert = {
          textData: {
            message: 'error_message_no_pending_request_found',
          },
          type: AlertType.Error,
        };

        dispatch(setAlert(alert));
      }

      handleAadhaarVerificationEngineChange(error?.data?.status);

      onFailed && onFailed();

      dispatch({ type: TypesUser.SEND_AADHAR_OTP_USER_ERROR });
    },
  });
};

export const postVerifyBankAccount: PostVerifyBankAccountType =
    (params) => (dispatch, getState) => {
      const { ifsc_code, account_number, onFailed, onSuccess } = params;
      const state = getState();

      const { id } = state.user.userInfo;
      dispatch({ type: TypesUser.POST_VERIFY_BANK_ACCOUNT_REQUEST });

      return WebApi.request({
        method: 'POST',
        url: `/api/users/${id}/verify_bank_account`,
        data: { ifsc_code, account_number },

        onSuccess: (data) => {
          if (data.message) {
            dispatch(getUserInfo());
          } else {
            onSuccess && onSuccess();
            dispatch({ type: TypesUser.POST_VERIFY_BANK_ACCOUNT_SUCCESS });
          }
        },

        onFailed: (error) => {
          if (error.data.status === 400) {
            const alertData = {
              textData: {
                message: 'error_message_bank_account_used',
                serverMessage: error.data.error,
              },
              type: AlertType.Error,
            };

            onSubmitEventTagHandler(
                {
                  message: error.data.error,
                },
                GTM_LABEL_SIGN_UP,
                'bank_card_2'
            );

            onFailed && onFailed();
            dispatch(setAlert(alertData));
            dispatch(getUserInfo());
            dispatch({ type: TypesUser.POST_VERIFY_BANK_ACCOUNT_ERROR });
          } else {
            const alertData = {
              textData: {
                message: 'error_message_an_error_occurred',
              },
              type: AlertType.Error,
            };

            onFailed && onFailed();
            dispatch(setAlert(alertData));
            dispatch({ type: TypesUser.POST_VERIFY_BANK_ACCOUNT_ERROR });
          }
        },
        isAuth: true,
      });
    };

export const getVerifyBankAccount: GetVerifyBankAccountType = (params) => (dispatch, getState) => {
  const { onSuccess, onFailed } = params;
  const state = getState();
  const { id } = state.user.userInfo;

  dispatch({ type: TypesUser.GET_VERIFY_BANK_ACCOUNT_REQUEST });

  return WebApi.request({
    method: 'GET',
    url: `/api/users/${id}/verify_bank_account`,

    onSuccess: (res) => {
      const getRetry = async () => {
        await getDelay(3000);
        dispatch(getVerifyBankAccount(params));
      };

      switch (res.state) {
        case VerifyBankAccountState.PENDING:
        case VerifyBankAccountState.POSTPONED:
          dispatch({ type: TypesUser.GET_VERIFY_BANK_ACCOUNT_REQUEST, data: res });
          return getRetry();

        case VerifyBankAccountState.SUCCESS:
        case VerifyBankAccountState.PROCESSED:
          const successAlert = {
            textData: {
              message: 'success_message_an_change_bank_details',
            },
            type: AlertType.Success,
            auto_close_after_secs: 10,
          };
          if (window.location.href.split('/')[3] !== 'registration') {
            localStorage.removeItem('IFCS');
            dispatch(setAlert(successAlert));
          }
          //TODO in future without setTimout
          setTimeout(() => {
            onSuccess && onSuccess();
            dispatch({ type: TypesUser.GET_VERIFY_BANK_ACCOUNT_SUCCESS, data: res });

            dispatch(redirect(PATH_ACC_APPLICATION));
          }, 3500);
          return;

        case VerifyBankAccountState.ERROR: {
          onFailed && onFailed();
          return;
        }

        case VerifyBankAccountState.FAILURE: {
          onFailed && onFailed();
          return dispatch({ type: TypesUser.GET_VERIFY_BANK_ACCOUNT_ERROR });
        }

        default:
          return getRetry();
      }
    },
    onFailed: (error) => {
      onSubmitEventTagHandler({ message: error.data.error }, GTM_LABEL_SIGN_UP, 'bank_card_2');

      const alertData = {
        textData: {
          message: 'error_message_an_error_occurred',
          serverMessage: error.data.error,
        },
        type: AlertType.Error,
      };

      dispatch(setAlert(alertData));
      return dispatch({ type: TypesUser.GET_VERIFY_BANK_ACCOUNT_ERROR });
    },

    isAuth: true,
  });
};

export const getVerifyIFCS: GetVerifyIFCSType = (params) => (dispatch) => {
  const { ifsc_code, onSuccess, onFailed } = params;

  dispatch({ type: TypesUser.GET_IFCS_REQUEST });

  return WebApi.request({
    method: 'GET',
    url: `/api/bank/ifsc/${ifsc_code}/short_info`,
    onSuccess: (data) => {
      onSuccess && onSuccess(data);
      dispatch({ type: TypesUser.GET_IFCS_SUCCESS, data });
    },
    onFailed: (error) => {
      if (error.data.status === 400) {
        const alert = {
          textData: {
            message: error.data.message,
          },
          type: AlertType.Error,
        };

        dispatch(setAlert(alert));
      }
      onFailed && onFailed(error);
      return dispatch({ type: TypesUser.GET_IFCS_ERROR, error });
    },

    isAuth: true,
  });
};

export const getExperianInfo: GetExperianType = (params) => (dispatch, getState) => {
  const { onSuccess, onFailed } = params;

  const state = getState();

  const { id } = state.user.userInfo;

  dispatch({ type: TypesUser.GET_EXPERIAN_INFO_REQUEST });

  return WebApi.request({
    method: 'GET',
    url: `/api/users/${id}/experian`,
    onSuccess: (data) => {
      dispatch({ type: TypesUser.GET_EXPERIAN_INFO_SUCCESS, data });
      onSuccess && onSuccess();
    },
    onFailed: (error) => {
      if (error.data.status === 412) {
        dispatch(redirect(steps.PATH_REGISTRATION_STEP_9));
      }
      dispatch({ type: TypesUser.GET_EXPERIAN_INFO_ERROR, error });
      onFailed && onFailed(error);
    },
    isAuth: true,
  });
};

export const getKycDetails: GetKycDetailsType = (params) => (dispatch, getState) => {
  const { onSuccess, onFailed } = params;

  const state = getState();

  const { id } = state.user.userInfo;

  dispatch({ type: TypesUser.GET_KYC_DETAILS_REQUEST });

  return WebApi.request({
    method: 'GET',
    url: `/api/users/${id}/kyc_details`,
    onSuccess: (data) => {
      dispatch({ type: TypesUser.GET_KYC_DETAILS_SUCCESS, data });
      onSuccess && onSuccess();
    },
    onFailed: (error) => {
      dispatch({ type: TypesUser.GET_KYC_DETAILS_ERROR, error });
      onFailed && onFailed(error);
    },
    isAuth: true,
  });
};

export const postExperianInfo = (): AppThunk<void> => (dispatch, getState) => {
  const state = getState();

  const { id } = state.user.userInfo;

  dispatch({ type: TypesUser.POST_EXPERIAN_INFO_REQUEST });

  return WebApi.request({
    method: 'POST',
    url: `/api/users/${id}/experian`,
    onSuccess: () => {
      setStorageIsExperianRequestExist('true');
      dispatch({ type: TypesUser.POST_EXPERIAN_INFO_SUCCESS });
    },
    onFailed: (error) => {
      if (error.data.status === 412) {
        dispatch(redirect(steps.PATH_REGISTRATION_STEP_9));
      }
      dispatch({ type: TypesUser.POST_EXPERIAN_INFO_ERROR, error });
    },
    isAuth: true,
  });
};

export const postBankStatementAnalysis = (): AppThunk<void> => (dispatch, getState) => {
  const state = getState();

  const { id } = state.user.userInfo;

  dispatch({ type: TypesUser.POST_BANK_STATEMENT_ANALYSIS_REQUEST });

  return WebApi.request({
    method: 'POST',
    url: `/api/users/${id}/bank_statement_analysis_request`,
    data: {},
    onSuccess: (data) => {
      dispatch({ type: TypesUser.POST_BANK_STATEMENT_ANALYSIS_SUCCESS, data });
    },
    onFailed: (error) => {
      dispatch({ type: TypesUser.POST_BANK_STATEMENT_ANALYSIS_ERROR, error });
    },
    isAuth: true,
  });
};

export const putSetuDataAnalysis: SetuDataAnalysisType =
    (params): AppThunk<void> =>
        (dispatch, getState) => {
          const { onSuccess, onFailed, ...values } = params;

          const state = getState();

          const { id } = state.user.userInfo;

          const kyc_request_id = state.user.kyc_details?.bank_statement_analysis.kyc_request_id;

          dispatch({ type: TypesUser.PUT_SETU_DATA_ANALYSIS_REQUEST });

          return WebApi.request({
            method: 'PUT',
            url: `/api/users/${id}/bank_statement_analysis_request/${kyc_request_id}`,
            data: values,
            onSuccess: (data) => {
              onSuccess && onSuccess();
              dispatch({ type: TypesUser.PUT_SETU_DATA_ANALYSIS_SUCCESS, data });
            },
            onFailed: (error) => {
              onFailed && onFailed();
              dispatch({ type: TypesUser.PUT_SETU_DATA_ANALYSIS_ERROR, error });
            },
            isAuth: true,
          });
        };

export const xDryRunConfirmationCodeExperian = (): AppThunk => (dispatch, getState) => {
  const state = getState();

  const id = state.user.userInfo.id;

  return WebApi.request({
    method: 'POST',
    url: `/api/kyc/experian/otp_generation/${id}`,
    headers: { 'X-Dry-Run': 1 },
    onSuccess: (data) => {},
    onFailed: (error) => {},
    isAuth: true,
  });
};

export const sendConfirmationCodeExperian: SendConfirmationCodeExperianType =
    (data = {}) =>
        async (dispatch, getState) => {
          const { onSuccess, onFailed } = data;

          const state = getState();

          const id = state.user.userInfo.id;

          dispatch({ type: TypesUser.SEND_CONFIRM_CODE_EXPERIAN_REQUEST });

          const response = await WebApi.request({
            method: 'POST',
            url: `/api/kyc/experian/otp_generation/${id}`,
            data: { ...data },
            onSuccess: (data) => {
              dispatch({ type: TypesUser.SEND_CONFIRM_CODE_EXPERIAN_SUCCESS, data });

              onSuccess && onSuccess();
            },
            onFailed: (error) => {
              if (error.data.status === 429) {
                const alertData = {
                  textData: {
                    message: error.data.detail,
                  },
                  type: AlertType.Error,
                };
                onFailed && onFailed(error.data);
                dispatch(setAlert(alertData));
              }

              const headers = error.data.headers;
              const retryAfter = headers['retry-after'];

              !!retryAfter && dispatch(saveRetryAfter(retryAfter));

              dispatch({ type: TypesUser.SEND_CONFIRM_CODE_EXPERIAN_ERROR, error });

              onFailed && onFailed(error);
            },
            onFinally: () => {},
            isAuth: true,
          });

          const retryAfter = response.request.getResponseHeader('retry-after');

          !!retryAfter && dispatch(saveRetryAfter(retryAfter));
        };

export const postConfirmationCodeExperian: PostConfirmationCodeExperianType =
    (data) => (dispatch, getState) => {
      const { onSuccess, onFailed } = data;
      const state = getState();

      const id = state.user.userInfo.id;

      const mobileNumber = state.user.userInfo.phone_number;

      dispatch({ type: TypesUser.POST_CONFIRM_CODE_EXPERIAN_REQUEST });

      return WebApi.request({
        method: 'POST',
        url: `/api/kyc/experian/otp_confirmation/${id}`,
        data: { ...data, mobileNumber },
        onSuccess: () => {
          onSuccess && onSuccess();
          dispatch({ type: TypesUser.POST_CONFIRM_CODE_EXPERIAN_SUCCESS, data });
        },
        onFailed: (error) => {
          const alertData = {
            textData: {
              message: 'error_message_otp_validation_failed',
            },
            type: AlertType.Error,
          };

          onFailed && onFailed(error.data);
          dispatch(setAlert(alertData));
          dispatch({
            type: TypesUser.POST_CONFIRM_CODE_EXPERIAN_ERROR,
            data: { request_error: 'error_message_an_error_occurred' },
          });
        },
        isAuth: true,
      });
    };

export const postUploadPanCard: UploadPanCardType = (file) => (dispatch, getState) => {
  dispatch({ type: TypesUser.POST_UPLOAD_PANCARD_FRONT_REQUEST });

  const state = getState();

  const id = state.user.userInfo.id;

  const data = file;

  return WebApi.request({
    method: 'POST',
    url: `/api/users/${id}/pancard`,
    data,
    onSuccess: (data) => {
      dispatch({ type: TypesUser.POST_UPLOAD_PANCARD_FRONT_SUCCESS, data });
    },
    onFailed: () => {
      const alertData = {
        textData: {
          message: 'error_message_pancard_not_uploaded',
        },
        type: AlertType.Error,
      };

      dispatch(setAlert(alertData));

      dispatch({ type: TypesUser.POST_UPLOAD_PANCARD_FRONT_ERROR });
    },
    isAuth: true,
  });
};

export const postUploadSelfieAndPanCard: UploadPanCardType = (file) => (dispatch, getState) => {
  dispatch({ type: TypesUser.POST_UPLOAD_SELFIE_AND_PANCARD_FRONT_REQUEST });

  const state = getState();

  const id = state.user.userInfo.id;

  const data = file;

  return WebApi.request({
    method: 'POST',
    url: `/api/users/${id}/selfie_with_pancard`,
    data,
    onSuccess: (data) => {
      dispatch({ type: TypesUser.POST_UPLOAD_SELFIE_AND_PANCARD_FRONT_SUCCESS, data });
    },
    onFailed: () => {
      const alertData = {
        textData: {
          message: 'error_message_selfie_not_uploaded',
        },
        type: AlertType.Error,
      };

      dispatch(setAlert(alertData));
      dispatch({ type: TypesUser.POST_UPLOAD_SELFIE_AND_PANCARD_FRONT_ERROR });
    },
    isAuth: true,
  });
};
export const postConsentGiven = (): AppThunk => (dispatch, getState) => {
  dispatch({ type: TypesUser.POST_CONSENT_GIVEN_REQUEST });

  const state = getState();

  const id = state.user.userInfo.id;

  return WebApi.request({
    method: 'POST',
    url: `/api/users/${id}/post_consent`,

    onSuccess: (data) => {
      dispatch({ type: TypesUser.POST_CONSENT_GIVEN_SUCCESS, data });
      dispatch(getUserInfo());
    },
    onFailed: () => {
      const alertData = {
        textData: {
          message: 'error_message_no_post_consent_request',
        },
        type: AlertType.Error,
      };

      dispatch(setAlert(alertData));
      dispatch({ type: TypesUser.POST_CONSENT_GIVEN_ERROR });
    },
    isAuth: true,
  });
};

export const postOzForensics: OzLivenessResultType =
  (data): AppThunk<void> =>
    (dispatch) => {
      const { onSuccess, onFailed } = data;
      dispatch({ type: TypesUser.POST_OZ_FORENSICS_REQUEST });
      return WebApi.request({
        method: 'POST',
        url: `/api/liveness/oz-forensics`,
        data: { ...data },
        onSuccess: (data) => {
          onSuccess && onSuccess();
          dispatch(setOzLivenessAuthDataStorage({ ...data }));
          dispatch({ type: TypesUser.POST_OZ_FORENSICS_SUCCESS, data });
          onSuccess && onSuccess();
        },
        onFailed: (error) => {
          onFailed && onFailed(error);
          dispatch(getUserInfo());
          dispatch({ type: TypesUser.POST_OZ_FORENSICS_ERROR, error });
          onFailed && onFailed();
        },
        isAuth: true,
      });
    };

export const postOzLivenessResult = (result: string): AppThunk<void> => (dispatch) => {
  const transaction_id = getStorageForensicsTransactionId();

  dispatch({ type: TypesUser.POST_OZ_LIVENESS_RESULT_REQUEST });
  dispatch(() => setStorageSelfieRequest('true'));

  return WebApi.request({
    method: 'POST',
    url: `/api/liveness/oz-forensics/${transaction_id}`,
    onSuccess: (data) => {
      dispatch(() => removeStorageSelfieRequest());
      dispatch({ type: TypesUser.POST_OZ_LIVENESS_RESULT_SUCCESS, data });
    },
    onFailed: (error) => {
      if (error.data.status === 400) {
        dispatch(() => removeStorageForensicsAccessToken());
        dispatch(() => removeStorageForensicsTransactionId());
      }

      const alertData = {
        textData: {
          message: 'error_message_selfie_not_uploaded',
        },
        type: AlertType.Error,
      };

      dispatch(setAlert(alertData));
      dispatch(getUserInfo());
      dispatch({ type: TypesUser.POST_OZ_LIVENESS_RESULT_ERROR, error });
    },
    isAuth: true,
  });
};

export const postOzLivenessErrorResult = (result: string): AppThunk<void> => (dispatch) => {
  const transaction_id = getStorageForensicsTransactionId();

  return WebApi.request({
    method: 'POST',
    url: `/api/liveness/oz-forensics/${transaction_id}`,
    data: {
      'oz_result': result,
      'is_success': false
    },
    onSuccess: (data) => {
    },
    onFailed: (error) => {
    },
    isAuth: true,
  });
};

export const getAppSettings = (): AppThunk => (dispatch) => {
  dispatch({ type: TypesUser.GET_APP_SETTINGS_REQUEST });

  return WebApi.request({
    method: 'GET',
    url: '/api/common/settings/react_app',
    data: {},
    onSuccess: (data) => {
      dispatch({ type: TypesUser.GET_APP_SETTINGS_SUCCESS, data });
    },
    onFailed: () => {
      dispatch({ type: TypesUser.GET_APP_SETTINGS_ERROR });
    },
    isAuth: true,
  });
};
